// Mirrors backend diet_badges.DIET_LABELS. Slugs double as /diet/<slug> pages (except pescatarian).
export const DIET_LABELS = {
  vegan: "Vegan",
  vegetarian: "Vegetarian",
  pescatarian: "Pescatarian",
  "gluten-free": "Coeliac / Gluten-Free",
  "dairy-free": "Lactose / Dairy-Free",
  "egg-free": "Egg Allergy",
  "nut-free": "Nut-Free",
  "soy-free": "Soy-Free",
  "low-fodmap": "Low-FODMAP",
  "low-histamine": "Low-Histamine",
  "diabetic-friendly": "Diabetic / Low-Glycemic",
  "renal-friendly": "Renal / Kidney-Friendly",
};
export const SHORT_LABELS = { ...DIET_LABELS, "gluten-free": "Gluten-Free", "dairy-free": "Dairy-Free", "egg-free": "Egg-Free", "diabetic-friendly": "Low-GI", "renal-friendly": "Kidney-Friendly" };
export const dietHref = (slug) => (slug === "pescatarian" ? "/search?q=pescatarian" : `/diet/${slug}`);

// Spoken / typed diet phrases → badge slug (longest first so "nut free" beats "nut").
const PHRASES = [
  ["gluten free", "gluten-free"], ["coeliac", "gluten-free"], ["celiac", "gluten-free"],
  ["dairy free", "dairy-free"], ["lactose free", "dairy-free"], ["egg free", "egg-free"], ["without eggs?", "egg-free"],
  ["nut free", "nut-free"], ["without nuts", "nut-free"], ["soya? free", "soy-free"], ["low fodmap", "low-fodmap"],
  ["fodmap", "low-fodmap"], ["low histamine", "low-histamine"], ["diabetic(?: friendly)?", "diabetic-friendly"],
  ["low (?:gi|glycaemic|glycemic)", "diabetic-friendly"], ["(?:kidney|renal) friendly", "renal-friendly"],
  ["plant based", "vegan"], ["vegan", "vegan"], ["vegetarian", "vegetarian"], ["veggie", "vegetarian"],
  ["meat free", "vegetarian"], ["pesc[ae]tarian", "pescatarian"],
];
const PHRASE_RX = new RegExp(`\\b(?:${PHRASES.map(([p]) => `(${p.replace(/ /g, "[\\s-]+")})`).join("|")})\\b`, "gi");

// "show me nut-free vegan dinners" → { diets: ["nut-free","vegan"], rest: "show me dinners" }
export function findDiets(text) {
  const diets = [];
  const rest = (text || "").replace(PHRASE_RX, (...m) => {
    const i = m.slice(1, PHRASES.length + 1).findIndex((g) => g !== undefined);
    const slug = PHRASES[i]?.[1];
    if (slug && !diets.includes(slug)) diets.push(slug);
    return " ";
  }).replace(/\s+/g, " ").trim();
  return { diets, rest };
}
export const dietListLabel = (slugs) => {
  const l = slugs.map((s) => SHORT_LABELS[s] || s);
  return l.length > 1 ? `${l.slice(0, -1).join(", ")} and ${l[l.length - 1]}` : l[0] || "";
};
